"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _lock = _interopRequireDefault(require("cccisd-icons/svg/lock4"));
var _play = _interopRequireDefault(require("cccisd-icons/svg/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/svg/spinner11"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdColorPicker = require("cccisd-color-picker");
var _style = _interopRequireDefault(require("../style.css"));
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var translate = {
  en: {
    lessonText: 'LESSON',
    play: 'Play',
    quickReview: 'QUICK REVIEW',
    replay: 'Replay',
    resume: 'Resume'
  },
  es: {
    lessonText: 'LECCIÓN',
    play: 'Empezar',
    quickReview: 'REVISIÓN RÁPIDA',
    replay: 'Repetirse',
    resume: 'Reanudar'
  }
};
var LessonCard = function LessonCard(_ref) {
  var baseColor = _ref.baseColor,
    buttonColors = _ref.buttonColors,
    getLessonHighlight = _ref.getLessonHighlight,
    getLessonLabel = _ref.getLessonLabel,
    item = _ref.item,
    language = _ref.language,
    lessonNum = _ref.lessonNum,
    _ref$lessons = _ref.lessons,
    lessons = _ref$lessons === void 0 ? [] : _ref$lessons,
    progressBubbleColors = _ref.progressBubbleColors,
    renderPinnedContent = _ref.renderPinnedContent,
    showLastVisited = _ref.showLastVisited,
    showLessonNum = _ref.showLessonNum,
    showProgressBubbleNum = _ref.showProgressBubbleNum;
  language = Object.keys(translate).includes(language) ? language : 'en';
  var action = getAction(item);
  var hasNextLesson = lessons.length >= lessonNum + 2;
  var lessonAreaRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(109),
    _useState2 = _slicedToArray(_useState, 2),
    lessonAreaHeight = _useState2[0],
    setLessonAreaHeight = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hovering = _useState4[0],
    setHovering = _useState4[1];
  var pinnedContent = (0, _get2["default"])(item, 'pinnedContent', []) || [];
  var baseColorHex = (0, _cccisdColorPicker.getColor)(baseColor);
  (0, _react.useEffect)(function () {
    if (lessonAreaRef.current && lessonAreaRef.current.offsetHeight !== lessonAreaHeight) {
      setLessonAreaHeight(lessonAreaRef.current.offsetHeight);
    }
    function handleResize() {
      if (lessonAreaRef.current && lessonAreaRef.current.offsetHeight !== lessonAreaHeight) {
        setLessonAreaHeight(lessonAreaRef.current.offsetHeight);
      }
    }
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
  function getAction(lesson) {
    switch (true) {
      case lesson.isCompleted:
        return 'replay';
      case lesson.isResume:
        return 'resume';
      default:
        return 'play';
    }
  }
  function renderActionButton() {
    var playIcon = item.isAllowed ? /*#__PURE__*/_react["default"].createElement(_play["default"], null) : /*#__PURE__*/_react["default"].createElement(_lock["default"], null);
    var buttonData = {
      play: {
        className: 'btn-info',
        icon: playIcon,
        color: (0, _cccisdColorPicker.getColor)(buttonColors.start)
      },
      resume: {
        className: 'btn-primary',
        icon: null,
        color: (0, _cccisdColorPicker.getColor)(buttonColors.resume)
      },
      replay: {
        className: _style["default"].grayButton,
        icon: /*#__PURE__*/_react["default"].createElement(_spinner["default"], null),
        color: (0, _cccisdColorPicker.getColor)(buttonColors.replay)
      }
    };
    var buttonText = translate[language][action];
    var buttonInfo = buttonData[action];

    // presenter mode always starts user fresh back at beginning,
    // so always use text that matches behavior
    if (item.isPresenterMode) {
      buttonText = translate[language].play;
      buttonInfo = buttonData.play;
    }
    var buttonColor = (0, _color["default"])(buttonInfo.color);
    var buttonContrast = buttonColor.contrast((0, _color["default"])('#ffffff'));
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: (0, _classnames["default"])('btn btn-block', !buttonInfo.color && buttonInfo.className, !item.isAllowed && 'disabled'),
      onClick: item.setCurrent,
      style: buttonInfo.color ? {
        color: buttonContrast >= 2.99 ? '#fff' : '#333',
        backgroundColor: hovering && item.isAllowed ? buttonColor.darken(0.05) : buttonInfo.color,
        borderColor: buttonColor.lighten(0.25),
        width: '100%'
      } : {
        width: '100%'
      },
      onMouseEnter: function onMouseEnter() {
        setHovering(true);
      },
      onMouseLeave: function onMouseLeave() {
        setHovering(false);
      }
    }, buttonInfo.icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].actionIcon
    }, buttonInfo.icon, "\xA0"), buttonText);
  }

  /*
   * Quick Review is old JSON structure.
   * Pinned Content is new JSON structure.
   */
  function renderQuickReview() {
    if (!item.quickReview && pinnedContent.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
    var quickReview = /*#__PURE__*/_react["default"].createElement("div", null);
    if (item.quickReview) {
      // setting can be { "quickReviewTitle": "" } to turn it completely off
      var quickReviewTitle = 'quickReviewTitle' in item ? item.quickReviewTitle : translate[language].quickReview;
      quickReview = /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].quickReviewWrapper
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].quickReviewTitle
      }, quickReviewTitle), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: item.quickReview
      }));
    }
    var pinned = /*#__PURE__*/_react["default"].createElement("div", null);
    if (pinnedContent.length > 0) {
      pinned = /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].pinnedContentWrapper
      }, pinnedContent.map(renderPinnedContent));
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, quickReview, pinned);
  }
  function renderLessonMain() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonCard,
      ref: lessonAreaRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonInnerWrapper
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].lessonText,
      style: {
        color: "".concat(baseColorHex),
        marginBottom: item.title ? '-0.2rem' : '0.6rem'
      }
    }, getLessonHighlight(item), showLessonNum && "".concat(getLessonLabel().toUpperCase(), " ").concat(lessonNum + 1)), item.title && /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb-2"
    }, typeof item.title === 'string' ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: item.title
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: item.title.content
    })), renderActionButton(), showLastVisited && item.lastVisited && /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].lastVisited
    }, "Last visited", ' ', (0, _dateFns.format)((0, _dateFns.subMinutes)(new Date(item.lastVisited), new Date().getTimezoneOffset()), 'MM/dd/yyyy'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].quickReviewDivider, !!item.quickReview && _style["default"].quickReviewDividerColor)
    }), renderQuickReview());
  }
  function renderLessonStatus() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonStatusOuter, _style["default"]["lesson".concat(action)]),
      style: progressBubbleColors[action] ? {
        background: (0, _cccisdColorPicker.getColor)(progressBubbleColors[action])
      } : {}
    }, action === 'resume' && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonplay, _style["default"].lessonStatusOuterPartial)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].lessonStatusInner
    }, showProgressBubbleNum ? lessonNum + 1 : null)), hasNextLesson && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].lessonStatusBeam, _style["default"]["lesson".concat(action)]),
      style: _objectSpread({
        height: "".concat(lessonAreaHeight, "px")
      }, progressBubbleColors[action] ? {
        background: (0, _cccisdColorPicker.getColor)(progressBubbleColors[action])
      } : {})
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, renderLessonStatus(), renderLessonMain());
};
var _default = exports["default"] = LessonCard;